// import { Image } from "@heroui/image";
// import { Spacer } from "@heroui/spacer";

// import { Img33, TextStrip3 } from "@/public/assets";
// import { ApplyForJob, FindTalent } from "@/components";

// const TrackRecord = () => {
//     return (
//         <section className="max-w-screen-2xl mx-auto lg:px-28 px-6 py-12">
//             <div className="mb-4 text-black dark:text-foreground-950 text-[32px] text-center mx-auto font-medium leading-10 tracking-[-0.16px]">
//                 We bring you a proven <br />{" "}
//                 <span className="italic text-primary-600 dark:text-primary relative">
//                     track record
//                     <div className="absolute -bottom-1 inset-x-0">
//                         <Image
//                             disableSkeleton
//                             alt="strip 2 image"
//                             className="animate__animated animate__flipInX w-full"
//                             src={TextStrip3.src}
//                         />
//                     </div>
//                 </span>{" "}
//                 and talent you can trust.
//             </div>

//             <div className="text-foreground-700 dark:text-foreground-600 font-normal text-base leading-6 tracking-[-0.176px] mb-6 text-center max-w-2xl px-10 mx-auto">
//                 At Cotton Recruiting, results speak for themselves with faster hires,
//                 higher retention, and teams your business can rely on
//             </div>

//             <div className="flex items-center mb-9 gap-3 justify-center mx-auto max-w-md">
//                 <FindTalent />
//                 <ApplyForJob />
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 w-8/12 mx-auto">
//                 {/* LEFT IMAGE */}
//                 <Image
//                     removeWrapper
//                     alt="person"
//                     className="object-cover h-full"
//                     src={Img33.src}
//                 />

//                 {/* RIGHT CONTENT */}
//                 <div className="lg:col-span-2 flex flex-col gap-2">
//                     {/* TOP CARDS */}
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
//                         {/* CARD 1 */}
//                         <div className="bg-[#F9FAFB] dark:bg-foreground-50 rounded-2xl gap-4 flex flex-col justify-between items-start p-4 flex-1 self-stretch">
//                             <span className="text-primary-700 dark:text-primary bg-primary-50 dark:bg-primary-50 w-fit px-2 py-1 text-[11px] font-medium leading-3 tracking-[0.22px] rounded-full">
//                                 Successful Placements
//                             </span>

//                             <Spacer y={10} />

//                             <div className="text-[62.941px] font-medium text-black dark:text-foreground-950 tracking-[-0.629px]">
//                                 98
//                                 <span className="text-foreground-700 dark:text-foreground-600 text-[37.765px] tracking-[-0.378px]">
//                                     %
//                                 </span>
//                             </div>

//                             <p className="text-sm text-foreground-700 dark:text-foreground-600 leading-5 tracking-[-0.084px] -mt-5">
//                                 Almost every candidate is a long-term fit, helping your business
//                                 grow.
//                             </p>
//                         </div>

//                         {/* CARD 2 */}
//                         <div className="bg-[#F9FAFB] dark:bg-foreground-50 rounded-2xl gap-4 flex flex-col justify-between items-start p-4 flex-1 self-stretch">
//                             <span className="text-secondary-500 dark:text-secondary bg-secondary-50 dark:bg-secondary-50 w-fit px-2 py-1 text-[11px] font-medium leading-3 tracking-[0.22px] rounded-full">
//                                 Client Satisfaction
//                             </span>

//                             <Spacer y={10} />

//                             <div className="text-[62.941px] font-medium text-black dark:text-foreground-950 tracking-[-0.629px]">
//                                 <span className="text-foreground-700 dark:text-foreground-600 text-[37.765px] tracking-[-0.378px]">
//                                     #
//                                 </span>
//                                 1
//                             </div>

//                             <p className="text-sm text-foreground-700 dark:text-foreground-600 leading-5 tracking-[-0.084px] -mt-5">
//                                 We deliver talent that integrates, contributes, and stays.
//                             </p>
//                         </div>
//                     </div>

//                     {/* BOTTOM CARD */}
//                     <div className="bg-[#F9FAFB] dark:bg-foreground-50 rounded-2xl gap-4 flex flex-col justify-between items-start p-4 flex-1 self-stretch">
//                         <span className="text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-foreground-100 w-fit px-2 py-1 text-[11px] font-medium leading-3 tracking-[0.22px] rounded-full">
//                             Faster Time-to-Hire
//                         </span>

//                         <Spacer y={10} />

//                         <div className="text-[62.941px] font-medium text-black dark:text-foreground-950 tracking-[-0.629px]">
//                             85
//                             <span className="text-foreground-700 dark:text-foreground-600 text-[37.765px] tracking-[-0.378px]">
//                                 %
//                             </span>
//                         </div>

//                         <p className="text-sm text-foreground-700 dark:text-foreground-600 leading-5 tracking-[-0.084px] -mt-5">
//                             Streamlined recruitment processes and pre-vetted candidates mean
//                             businesses get the people they need—quickly, without compromising
//                             quality.
//                         </p>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default TrackRecord;

import { Image } from "@heroui/image";
import { Spacer } from "@heroui/spacer";

import { Img33, TextStrip3 } from "@/public/assets";
import { ApplyForJob, FindTalent } from "@/components";

const TrackRecord = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 py-10 sm:py-12">
      <div
        className="mb-4 text-black dark:text-foreground-950 text-[24px] sm:text-[28px] md:text-[32px] text-center mx-auto font-medium leading-8 sm:leading-9 md:leading-10 tracking-[-0.16px]"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        We bring you a proven <br />{" "}
        <span className="italic text-primary-600 dark:text-primary relative">
          track record
          <div className="absolute -bottom-1 inset-x-0">
            <Image
              disableSkeleton
              alt="strip 2 image"
              className="animate__animated animate__flipInX w-full"
              src={TextStrip3.src}
            />
          </div>
        </span>{" "}
        and talent you can trust.
      </div>

      <div
        className="text-foreground-700 dark:text-foreground-600 font-normal text-sm sm:text-base leading-5 sm:leading-6 tracking-[-0.176px] mb-6 text-center max-w-2xl px-2 sm:px-6 md:px-10 mx-auto"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        At Cotton Recruiting, results speak for themselves with faster hires,
        higher retention, and teams your business can rely on
      </div>

      <div
        className="flex flex-col sm:flex-row items-center mb-9 gap-3 justify-center mx-auto max-w-md"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <FindTalent />
        <ApplyForJob />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 w-full sm:w-10/12 md:w-9/12 lg:w-8/12 mx-auto">
        {/* LEFT IMAGE */}
        <div data-aos="fade-right" data-aos-delay="300">
          <Image
            removeWrapper
            alt="person"
            className="object-cover h-[35vh] sm:h-[45vh] lg:h-full w-full rounded-[20px] sm:rounded-[24px] lg:rounded-none"
            src={Img33.src}
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="lg:col-span-2 flex flex-col gap-2">
          {/* TOP CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {/* CARD 1 */}
            <div
              className="bg-[#F9FAFB] dark:bg-foreground-50 rounded-2xl gap-4 flex flex-col justify-between items-start p-4 flex-1 self-stretch"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <span className="text-primary-700 dark:text-primary bg-primary-50 dark:bg-primary-50 w-fit px-2 py-1 text-[11px] font-medium leading-3 tracking-[0.22px] rounded-full">
                Successful Placements
              </span>

              <Spacer y={6} />

              <div className="text-[42px] sm:text-[52px] lg:text-[62.941px] font-medium text-black dark:text-foreground-950 tracking-[-0.629px]">
                98
                <span className="text-foreground-700 dark:text-foreground-600 text-[24px] sm:text-[30px] lg:text-[37.765px] tracking-[-0.378px]">
                  %
                </span>
              </div>

              <p className="text-sm text-foreground-700 dark:text-foreground-600 leading-5 tracking-[-0.084px] -mt-2 sm:-mt-5">
                Almost every candidate is a long-term fit, helping your business
                grow.
              </p>
            </div>

            {/* CARD 2 */}
            <div
              className="bg-[#F9FAFB] dark:bg-foreground-50 rounded-2xl gap-4 flex flex-col justify-between items-start p-4 flex-1 self-stretch"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <span className="text-secondary-500 dark:text-secondary bg-secondary-50 dark:bg-secondary-50 w-fit px-2 py-1 text-[11px] font-medium leading-3 tracking-[0.22px] rounded-full">
                Client Satisfaction
              </span>

              <Spacer y={6} />

              <div className="text-[42px] sm:text-[52px] lg:text-[62.941px] font-medium text-black dark:text-foreground-950 tracking-[-0.629px]">
                <span className="text-foreground-700 dark:text-foreground-600 text-[24px] sm:text-[30px] lg:text-[37.765px] tracking-[-0.378px]">
                  #
                </span>
                1
              </div>

              <p className="text-sm text-foreground-700 dark:text-foreground-600 leading-5 tracking-[-0.084px] -mt-2 sm:-mt-5">
                We deliver talent that integrates, contributes, and stays.
              </p>
            </div>
          </div>

          {/* BOTTOM CARD */}
          <div
            className="bg-[#F9FAFB] dark:bg-foreground-50 rounded-2xl gap-4 flex flex-col justify-between items-start p-4 flex-1 self-stretch"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <span className="text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-foreground-100 w-fit px-2 py-1 text-[11px] font-medium leading-3 tracking-[0.22px] rounded-full">
              Faster Time-to-Hire
            </span>

            <Spacer y={6} />

            <div className="text-[42px] sm:text-[52px] lg:text-[62.941px] font-medium text-black dark:text-foreground-950 tracking-[-0.629px]">
              85
              <span className="text-foreground-700 dark:text-foreground-600 text-[24px] sm:text-[30px] lg:text-[37.765px] tracking-[-0.378px]">
                %
              </span>
            </div>

            <p className="text-sm text-foreground-700 dark:text-foreground-600 leading-5 tracking-[-0.084px] -mt-2 sm:-mt-5">
              Streamlined recruitment processes and pre-vetted candidates mean
              businesses get the people they need—quickly, without compromising
              quality.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;
